module.exports = __webpack_public_path__ + "static/tw-mobile-visualize-a034f948a8094709378046a119f06b62.jpg";